module.exports = __webpack_public_path__ + "img/file_copy.598b3ad3.svg";